import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MapLatLangToDirectionResultService } from './map-lat-lang-to-direction-result.service';

@Pipe({
  name: 'mapLatLangToDirectionResult',
  standalone: true,
})
export class MapLatLangToDirectionResultPipe implements PipeTransform {
  mapLatLangToDirectionResultService = inject(MapLatLangToDirectionResultService);

  transform(value: google.maps.LatLng[]): Observable<google.maps.DirectionsResult> {
    return of(value).pipe(this.mapLatLangToDirectionResultService.mapLatLangToDirectionResult);
  }
}
